import { useEffect, useState } from 'react';
import { AppState } from 'react-native';
import { useNativeEvent } from './useNativeEvent';
import { useInstanceId } from './useInstanceId';

/**
 * 현재 화면이 포그라운드에 있는지 판별하는 훅
 * - Activity 포커스 (viewDidAppear/viewDidDisappear) + OS 포그라운드 (AppState) 모두 반영
 * - iOS: sceneDidEnterBackground 시 viewDidDisappear를 emit하지 않으므로 AppState 병행 필요
 * - Android: 백스택 Activity의 AppState 리스너 오작동 방지 (isActivityForeground && isAppActive)
 */
export const useIsForegroundNow = () => {
  const instanceId = useInstanceId();
  const [isActivityForeground, setIsActivityForeground] = useState(true);
  const [isAppActive, setIsAppActive] = useState(
    () => AppState.currentState === 'active',
  );

  useNativeEvent('viewDidAppear', instanceId, () =>
    setIsActivityForeground(true),
  );
  useNativeEvent('viewDidDisappear', instanceId, () =>
    setIsActivityForeground(false),
  );

  useEffect(() => {
    const sub = AppState.addEventListener('change', next => {
      setIsAppActive(next === 'active');
    });
    return () => sub.remove();
  }, []);

  return isActivityForeground && isAppActive;
};
